<template>
  <div class="talent">
    <div class="talent-table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="姓名"></el-table-column>
        <el-table-column prop="name" label="年龄"></el-table-column>
        <el-table-column prop="name" label="工龄"></el-table-column>
        <el-table-column prop="name" label="专业技能"></el-table-column>
        <el-table-column prop="address" label="个人简介"></el-table-column>
        <el-table-column label="证书" width="144">
          <template slot-scope="props">
            <div>
              <el-carousel class="talent-carousel" trigger="click" :autoplay="false" arrow="never" height="90px">
                <el-carousel-item v-for="item in props.row.pics" :key="item">
                  <img style="width: 100%; height: 100%; display: block;" :src="item" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          pics: [
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849'
          ]
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          pics: [
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849'
          ]
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          pics: [
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849'
          ]
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          pics: [
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849',
            'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/machine/610000/20190616312012465824849'
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.talent {
  border: 1px solid #e4e7ed;
  border-bottom: none;
}
</style>
<style>
.talent-carousel .el-carousel__indicators{

}
.talent-carousel .el-carousel__indicators .el-carousel__indicator{

}
.talent-carousel .el-carousel__indicators .el-carousel__indicator .el-carousel__button{
    width: 6px;
    height: 6px;
    border-radius: 6px;
}
</style>
